import { MetaLayerDefinition, SearchResultFlat } from '@agissc/ktag-map';
import useAppState from '../../AppStore';
import {
  useUserFavorite,
  useAddUserFavorite,
  useRemoveUserFavorite,
  UserFavorite,
} from './useFavoritesFromApi';

export const useFavorites = () => {
  const toggleFavoriteFromStore = useAppState((state) => state.toggleFavorite);
  const userFavoritesFromStore = useAppState((state) => state.favorites);
  const isLoggedIn = useAppState((state) => state.isLoggedIn);

  const useUserFavoriteFromApi = useUserFavorite();
  const useAddUserFavoriteFromApi = useAddUserFavorite();
  const useRemoveUserFavoriteFromApi = useRemoveUserFavorite();

  const getUserFavoritesValues = (favorites: UserFavorite[]) => {
    return favorites.reduce(
      (acc, favorite) => {
        const key = favorite.value.id as string;
        acc[key] = favorite.value;
        return acc;
      },
      {} as Record<string, SearchResultFlat | MetaLayerDefinition>,
    );
  };

  const getUserFavorites = () => {
    if (isLoggedIn) {
      const favorites = useUserFavoriteFromApi.data || [];
      return getUserFavoritesValues(favorites);
    }
    return userFavoritesFromStore;
  };

  const toggleUserFavorite = (item: SearchResultFlat | MetaLayerDefinition) => {
    if (isLoggedIn) {
      const favorites = useUserFavoriteFromApi.data || [];
      const userFavoritesDict = favorites.reduce(
        (acc, favorite) => {
          const key = favorite.value.id as string;
          acc[key] = favorite;
          return acc;
        },
        {} as Record<string, UserFavorite>,
      );
      const key = item.id as string;

      if (key in userFavoritesDict) {
        const favorite = userFavoritesDict[key] as UserFavorite;
        useRemoveUserFavoriteFromApi.mutate(favorite.id);
      } else {
        const userFavorite = {
          value: item,
          type: 'weight' in item ? 'address' : 'map',
        } as UserFavorite;
        useAddUserFavoriteFromApi.mutate(userFavorite);
      }
    } else {
      toggleFavoriteFromStore(item);
    }
  };

  return { getUserFavorites, toggleUserFavorite };
};
